/* @flow */
import { connect } from 'react-redux';
import { alphabetize } from 'trustar/utils';
import { List } from 'immutable';
import { pipe } from 'ramda';
import createDebugger from 'debug';

const debug = createDebugger('app:modules:companies:index.js'); // eslint-disable-line no-unused-vars

import { typeof Quota, type Company } from './types.js';
import * as actions from './actions.js';
import * as getters from './getters.js';

export const getQuota = (quotas: List<Quota>) =>
  (quotas && quotas.size > 0) ? quotas.first() : undefined;

export const getQuotaFromCompany = pipe(
  (company: Company) => company ? company.get('requestQuotas', List()) : List(),
  getQuota
);

/**
 * Connect a Select component (i.e. react-select) to paginated companies state
 * with search functionality.
 *
 * NOTE: In order to support some odd existing use cases in the codebase the
 * options prop can be overwritten. This means that if `options` is specified
 * the onus is on the calling code to ensure the the options object meets the
 * expected contract of react-select. Where possible prefer the options provided
 * automatically by the state mapper here.
 */

export const connectSelect = connect(
  (state) => {
    const options = getters.companies(state)
      .toList()
      .sort(alphabetize)
      .map(company => ({
        value: company.get('guid'),
        label: company.get('name'),
      }))
      .toJS();

    return {
      isLoading: getters.loading(state),
      options,
    };
  },
  (dispatch, ownProps) => (
  { // Shudder I don't like these anonymous declarations of redux connect TODO:Refactor
    search: query => dispatch(actions.fetchWithDefaults({ query, simpleFetch: true })),
    fetchInitial: () => dispatch(actions.fetchWithDefaults({ pageSize: 100, simpleFetch: !ownProps.fetchFullCompanyInfo})),
  }),
  (stateProps, dispatchProps, ownProps) => {
    const options = ownProps.options || stateProps.options; // See NOTE

    const onOpen = () => {
      if (ownProps.value) {
        dispatchProps.search(ownProps.value.label); // Do a search for the selected item so its in state
      } else {
        dispatchProps.fetchInitial();
      }
    };

    const onChange = (value) => {
      debug('[ onChange ]', value);
      if (value) {
        dispatchProps.search(value.label); // Do a search for the selected item so its in state
      } else {
        dispatchProps.fetchInitial();
      }
      ownProps.onChange(value);
    };

    const onInputChange = (text) => {
      if (!text) {
        debug('[ onInputChange ] NO VALUE');
        return;
      }

      dispatchProps.search(text); // Do a search for the selected item so its in state
    };

    return {
      ...ownProps,
      ...stateProps,
      ...dispatchProps,
      onMount: onOpen, // Also fetch on initial mount
      onOpen,
      onChange,
      onInputChange,
      options,
    };
  }
);


export { actions, getters };
export { default } from './stores.js';
export { default as epic } from './epics.js';



// WEBPACK FOOTER //
// ./src/app/modules/companies/index.js